/* @ngInject */
const bulletinOptions = (
  utils,
  types,
  excelStyles,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'bulletinFreinage'
    options.enableColor = true
    options.enableOwnerSheet = false
    options.firstRow = 5
    options.getBodyCells = self.getBodyCells
    options.getBodyCells2 = self.getBodyCells2
    options.secondSheet = 1
    options.style = excelStyles.bodyCell()
    options.style2 = excelStyles.noStyle
    return options
  }

  self.getBodyCells2 = ({ firstRow, }, wagons,) => {
    return [{
      name: 'B2',
      value: wagons.length,
      type: types.integer,
    }, {
      name: 'D2',
      value: `=SUM(TRAIN!B${firstRow}:B${wagons.length + firstRow})`,
      type: types.decimal,
    }, {
      name: 'E2',
      value: `=SUM(TRAIN!E${firstRow}:E${wagons.length + firstRow})`,
      type: types.integer,
    }, {
      name: 'F2',
      value: `=SUM(TRAIN!F${firstRow}:F${wagons.length + firstRow})`,
      type: types.integer,
    }, {
      name: 'B4',
      value: 1,
      type: types.integer,
    }, {
      name: 'C4',
      value: 'G1206',
    }, {
      name: 'D4',
      value: 20,
      type: types.decimal,
    }, {
      name: 'E4',
      value: 88000,
      type: types.integer,
    }, {
      name: 'F4',
      value: 73000,
      type: types.integer,
    }, {
      name: 'B12',
      value: `=SUM(B2:B10)`,
      type: types.integer,
    }, {
      name: 'D12',
      value: `=SUM(D2:D10)`,
      type: types.decimal,
    }, {
      name: 'E12',
      value: `=SUM(E2:E10)`,
      type: types.integer,
    }, {
      name: 'F12',
      value: `=SUM(F2:F10)`,
      type: types.integer,
    }, {
      name: 'A14',
      value: `=IF(C14 > 0.57, "Apte MA100 ( > 57%)", "Inapte MA100 ( < 57%)")`,
    }, {
      name: 'C14',
      value: `=(F12 / E12)`,
      type: types.percentage,
    }, {
      name: 'A17',
      value: `=IF(C17 > 0.5, "Apte MA90 ( > 50%)", "Inapte MA90 ( < 50%)")`,
    }, {
      name: 'C17',
      value: `=(F12 / E12)`,
      type: types.percentage,
    }, {
      name: 'E14',
      value: `=IF(C17 > 0.57, "APTE", "INAPTE")`,
      style: { bold: true, fontSize: 18, },
    }, {
      name: 'E17',
      value: `=IF(C17 > 0.5, "APTE", "INAPTE")`,
      style: { bold: true, fontSize: 18, },
    },]
  }

  self.getBodyCells = ({ currentRow, }, wagon,) => {
    return [{
      ref: 'id',
      name: 'A' + currentRow,
      value: wagon.id,
      type: types.wagonId,
    }, {
      ref: 'length',
      name: 'B' + currentRow,
      value: wagon.length,
      type: types.decimal,
    }, {
      ref: 'tare',
      name: 'C' + currentRow,
      value: wagon.tare || 0,
      type: types.integer,
    }, {
      name: 'D' + currentRow,
      value: 0,
      type: types.integer,
    }, {
      name: 'E' + currentRow,
      value: `=C${currentRow} + D${currentRow}`,
      type: types.integer,
    }, {
      name: 'F' + currentRow,
      value: `=IF(H${currentRow} = "Oui", 0, ${wagon.brakedMass || 0})`,
      type: types.integer,
    }, {
      ref: 'owner',
      name: 'G' + currentRow,
      value: wagon.owner,
    }, {
      ref: 'isolated',
      name: 'H' + currentRow,
      value: wagon.isolated,
    },]
  }

  return self
}
export default bulletinOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/bulletinFreinageOptions.resource.js